import * as React from 'react';
import DrawerMUI from '@material-ui/core/Drawer';

import ScrollableView from '../../scrollable-view';
import Divider from '../../divider';
import {
	DefaultHeader,
	DefaultFooter,
} from './elements';
import {
	Root,
	HeaderLayout,
	ContentLayout,
	FooterLayout,
} from './styled';


type AnchorType = 'top' | 'left' | 'bottom' | 'right';

export type DefaultDrawerProps = {
	ref?: any;
	width?: number;
	stateForMerge?: DefaultDrawerState;
}

export type DefaultDrawerState = {
	isOpen?: boolean;
	anchor?: AnchorType;
	header?: React.ReactNode;
	content?: React.ReactNode;
	footer?: React.ReactNode;
}

class DefaultDrawer extends React.Component<DefaultDrawerProps, DefaultDrawerState> {
	static displayName = 'DefaultDrawer';
	static defaultProps = {
		width: 420,
		defaultOpen: false,
	};
	state = {
		isOpen: false,
		anchor: 'right' as AnchorType,
		header: <DefaultHeader />,
		content: null,
		footer: <DefaultFooter />,
		...(this.props.stateForMerge || {})
	};

	public open = (state: Partial<DefaultDrawerState>) => this.setState({ ...state, isOpen: true });

	public close = () => {
		this.setState({ isOpen: false });
		setTimeout(() => this.reset(), 200);
	};

	public reset = () => {
		this.setState({
			header: <DefaultHeader />,
			content: null,
			footer: <DefaultFooter />,
		});
	};

	public setContent = (state: Partial<DefaultDrawerState>) => this.setState({ ...state });

	render() {
		const { width } = this.props;
		const {
			isOpen,
			anchor,
			header,
			content,
			footer
		} = this.state;
		const needAutoHeight = anchor === 'top' || anchor==='bottom';

		return (
			<DrawerMUI
				open={isOpen}
				anchor={anchor}
				PaperProps={{
					style: {
						width: anchor === 'left' || anchor==='right' ? width : '100%',
						maxWidth: '100%'
					}
				}}
				ModalProps={{
					onClose: (_, reason: string) => {
						if (reason !== 'backdropClick') {
							this.close();
						}
					}
				}}
				onClose={this.close}>
				<Root>
					<HeaderLayout>
						{header}
					</HeaderLayout>
					<Divider />
					<ScrollableView style={{ flex: '1 1 auto' }} autoHeight={needAutoHeight}>
						<ContentLayout>
							{content}
						</ContentLayout>
					</ScrollableView>
					{
						footer &&
						<React.Fragment>
							<Divider />
							<FooterLayout>
								{footer}
							</FooterLayout>
						</React.Fragment>
					}
				</Root>
			</DrawerMUI>
		);
	}
};

export default DefaultDrawer;
